<div class="dashboard--module-header">
    <h2 class="subheading-sm">High Credit Status<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
  <issues-high-balance-chart class="block-chart"></issues-high-balance-chart>
  <div class="block-detail">
    <table class="std-table stacked-sm" *ngIf="data.length > 0">
      <thead>
      <th>Consumer name</th>
      <th>Supply address</th>
      <th>Credit status</th>
      <th>Credit status date</th>
      </thead>
      <tbody>
          <tr *ngFor="let item of data">
              <td data-label="Consumer name">{{item.consumerName}}</td>
              <td data-label="Supply address">{{item.consumerAddress}}</td>
              <td data-label="Credit status">£{{item.creditStatus | number:'1.2-2' }}</td>
              <td data-label="Credit status date">{{item.creditStatusDateTime | date:'dd/MM/yyyy'}}</td>
              <td class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
          </tr>
      </tbody>
    </table>
    <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
  </div>
</div>
